import * as React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from 'consts';
import { ZonesLayout } from 'layouts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

export const ZonesNavigator = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  React.useEffect(() => {
    if (location.pathname.replace(`/${orgSlug}/`, '') === ROUTES.ZONES) {
      navigate(ROUTES.ZONES_ACTIVE);
    }
  }, [location.pathname]);

  return (
    <ZonesLayout>
      <Outlet />
    </ZonesLayout>
  );
};
